import { Group } from '@mantine/core';
import css from '../components/css/Shell.module.css';
import { Shell } from '../features/shell/Shell';
import '../theme/Colours.css';
import { Routes } from './Routes';

export function App() {
	return (
		<>
			<Shell>
				<Group className={css.maxContent}>
					<Group className={css.mainContent}>
						<Routes />
					</Group>
				</Group>
			</Shell>
		</>
	);
}
